import React, { Component, Fragment } from "react";
import { BrowserRouter, Switch, Route, Redirect, Link } from "react-router-dom";

export default class Menu extends Component {

    botaoAtivo(path) {
        if(window.location.pathname === path) {
            return { backgroundColor: "#148a9c" }
        }
        else return {}
    }

    render() {
        return (
            <Fragment>
                <a href="/sti"><button className="btn btn-btn-danger" >Voltar</button></a>
                <a href="/sti/dashboard"><button className="btn btn-primary" style={this.botaoAtivo("/sti/dashboard")}>Geral</button></a>
                <a href="/sti/dashboard/linha"><button className="btn btn-primary" style={this.botaoAtivo("/sti/dashboard/linha")}>Linha de Atuação</button></a>
                <a href="/sti/dashboard/portfolio"><button className="btn btn-primary" style={this.botaoAtivo("/sti/dashboard/portfolio")}>Portfólio</button></a>
                {/* <a href="/sti/dashboard/bi"><button className="btn btn-primary" style={this.botaoAtivo("/sti/dashboard/bi")}>BI</button></a> */}
            </Fragment>
        )
    }

}